import { Icon } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
import './TextItem.scss';

type TextItemProps = {
  title: string;
  url?: string;
  onDelete?: (title: string) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const TextItem = ({ title, url, onDelete, ...rest }: TextItemProps) => {
  return (
    <div className="text-item" {...rest}>
      {url ? (
        <Typography.Link ellipsis href={url} target="_blank">
          {title}
        </Typography.Link>
      ) : (
        <Typography.Text ellipsis>{title}</Typography.Text>
      )}
      {onDelete && (
        <Icon
          id="DeleteOutlined"
          alt="Delete"
          onClick={() => onDelete(title)}
        />
      )}
    </div>
  );
};

export default TextItem;
